export const cohortUploadListingConstants = {
    
    GETALLCOHORTUPLOADLISTING_REQUEST: 'GETALLCOHORTUPLOADLISTING_REQUEST',
    GETALLCOHORTUPLOADLISTING_REQUEST_END: 'GETALLCOHORTUPLOADLISTING_REQUEST_END',

    GETALLCOHORTUPLOADLISTING_SUCCESS: 'GETALLCOHORTUPLOADLISTING_SUCCESS',
    GETALLCOHORTUPLOADLISTING_FAILURE: 'GETALLCOHORTUPLOADLISTING_FAILURE',
    CLEAR_ALL_MESSAGE: 'CLEAR_ALL_MESSAGE',
};
